import { GateTypes, Registration, RegistrationTypes } from 'types/working-model';

// SSO changes keep the event gated when an audience list is attached; shared passcode blocks it (the flattened SSO form has no passcode field, so gated would reject everyone).
export default function deriveRegistrationTypeForSsoChange(
	registrationSettings: Registration | null | undefined,
): RegistrationTypes {
	if (!registrationSettings) return RegistrationTypes.open;

	const requirements = registrationSettings.requirements;
	const hasAudienceList = !!requirements?.[GateTypes.passcode_list]?.some(requirement => !!requirement?.passcodeList?.length);
	const hasSharedPasscode = !!requirements?.[GateTypes.shared_passcode];
	const hasTicketing = !!requirements?.[GateTypes.ticketing];

	return hasAudienceList && !hasSharedPasscode && !hasTicketing
		? RegistrationTypes.gated
		: RegistrationTypes.open;
}
